import TableTemplate from "../../TableTemplate/tableTemplate";
import {
  IOrderFunctions,
  OrderType,
  ShekarChanceReport,
  ShekarChanceTableSearchParam,
} from "../../../Interfaces/orderInterfaces";
import { getShekarChanceTable } from "../../../Requests/Order/orderRequests";
import { HuntChancesTableUI } from "./HuntChancesTableUI";
import { Report } from "../../../Interfaces/TableInterfaces";

interface HuntStrategyChancesTableProps {
  getData: (
    searchParameters: ShekarChanceTableSearchParam,
    offset: number | null,
    pageSize: number | null
  ) => Promise<Report<ShekarChanceReport>>;
}

const HuntStrategyChancesTable = ({
  getData,
}: HuntStrategyChancesTableProps) => {
  return (
    <TableTemplate<ShekarChanceTableSearchParam, ShekarChanceReport>
      getDataTable={getData}
      TableUI={HuntChancesTableUI}
      showIsLoading
    />
  );
};

export default HuntStrategyChancesTable;
